import { commonRegx } from "xcommon-node/src/common/commonRegx";

export class DtoFileMastersGetRes {
    public url: string = "";
}
